import { theme, Button, Card, Table } from 'components';
import styled from 'styled-components';

export const Flex = styled.div`
  display: flex;
`;

export const FlexColumn = styled(Flex)<{ addMargin?: boolean }>`
  flex-direction: column;
  ${({ addMargin }) => (addMargin ? `margin: 17px;` : '')}
`;

export const FlexAlign = styled(Flex)`
  align-items: center;
`;

export const NameContainer = styled(Flex)`
  align-items: space-between;
  justify-content: space-between;
  padding-right: 22px;
`;

export const Section = styled.div`
  width: 100%;
  max-width: 850px;
  background-color: white;
  border-radius: 8px;
`;

export const PadRight = styled.div`
  padding-right: 30px;
`;

export const SectionTitle = styled.h1`
  font-size: 16px;
`;

export const SectionHeaderSmall = styled.h3`
  margin: 17px;
`;

export const DetailText = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.45);
`;

export const LightDetailText = styled(DetailText)`
  font-weight: 400;
  line-height: 20px;
`;

export const DetailTextPadded = styled(DetailText)`
  padding-top: 6px;
`;

export const UserSectionTop = styled(Flex)`
  position: relative;
  padding-left: 31px;
  padding-top: 28px;
  padding-bottom: 30px;
`;

export const UserSectionBottom = styled(Flex)`
  padding-left: 41px;
  padding-right: 41px;
  padding-bottom: 28px;
  flex-direction: column;
  gap: 8px;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  border: 1px solid #ededed;
  margin-bottom: 30px;
`;

export const StyledCard = styled(Card)<{ $hideBorderBottom?: boolean }>`
  ${({ $hideBorderBottom }) =>
    $hideBorderBottom &&
    `.ant-card-head {
      border-bottom: 0px;
    }`}

  .ant-card-body {
    padding: 1px 0px;
  }
`;

export const Header = styled.div`
  padding: 25px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledTable = styled(Table)`
  padding: 0px 5px;
  .ant-table-tbody > tr > td {
    padding: 16px 10px;
  }
  .ant-table-cell::before {
    display: none;
  }
  .ant-table-thead > tr > th {
    background: white;
    padding: 10px;
    color: ${theme.gray7};
    font-size: 14px;
    font-weight: 600;
  }
  .ant-pagination {
    justify-content: center;
  }
`;

export const SubscriptionContainer = styled.div`
  display: block;
  align-items: center;
  border: 1px solid #f0f0f0;
  padding: 16px;
  border-radius: 4px;
`;
export const SubscriptionDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
export const SubscriptionButton = styled(Button)`
  margin-left: auto;
`;

export const SubscriptionLogo = styled.img``;
export const SubscriptionText = styled.div`
  font-weight: 500;
  margin-right: 5px;
`;
export const SubscriptionStatus = styled.div``;
export const SubscriptionButtonContainer = styled.div`
  margin-left: auto;
`;
export const SupraKeyDetail = styled.div`
  flex: 1;
  align-items: center;
`;
export const SupraKeyDetailsContainer = styled.div`
  display: flex;
  gap: 17px;
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
  margin-top: 17px;
`;
export const SupraKeyDetailLine = styled.div`
  display: flex;
  padding-top: 6px;
  color: #595959;
`;

export const SubscriptionSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 17px;
`;

export const VerticalContactContainer = styled(Flex)`
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
  margin-bottom: 8px;
  padding: 16px;

  > :nth-child(n + 2) {
    margin-bottom: 20px;
  }
  > :last-child {
    margin-bottom: 0px;
  }
`;

export const DetailsContainer = styled(Flex)`
  width: 100%;
  max-width: 850px;
  gap: 12px;
`;

export const Container = styled.div`
  padding: 16px;
`;
